import React, {useState, useEffect, useRef} from 'react'
import { CSSTransition } from 'react-transition-group'



const Masukan = ( {onAdd} ) => {
  const [text, setText] = useState('')  

  function useKey(key, cb) {
    const callbackRef = useRef(cb);
  
    useEffect(() => {
      callbackRef.current = cb;
    });
  
  
    useEffect(() => {
      function handle(event) {
        if (event.code === key) {
          callbackRef.current(event);
        }
      }
    
    document.addEventListener("keypress", handle);
    return () => document.removeEventListener("keypress", handle)
  }, [key]);
  
  }


  const onClick = () => {
    
    if(!text) {
      return
    }

    onAdd({text})
  }
  
  
  function handleEnter () {
    console.log("Enter key is pressed");
    
    if(!text) {
      return
    }

    onAdd({text})
  }

  useKey("Enter", handleEnter)

  document.addEventListener('DOMContentLoaded', onClick || handleEnter )
  
  return (
    <CSSTransition in={true} appear={true} timeout={600} classNames="fade">
        <div className='masukan'>
          <p id='petunjuk'>Input your surname</p>
          <input type="text" id="sname" maxLength='15' value={text} onChange={(e) => setText(e.target.value)}/>
          <button id="enter" onClick={onClick} >Enter</button>  
        </div>
    </CSSTransition>
    )
}

export default Masukan

